import { ChainId } from '@shared/utils/config/networks';
export default function getNetworkLogo(chain) {
    var _a, _b, _c, _d, _e, _f;
    try {
        if (chain == ChainId.AVALANCHE) {
            return "/static/geniusImages/network_logos/".concat((_b = (_a = ChainId[chain]) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase(), ".svg");
        }
        if (chain == ChainId.BSC) {
            return "/static/geniusImages/network_logos/binance.png";
        }
        if (chain == ChainId.BASE) {
            return "/static/geniusImages/network_logos/".concat((_d = (_c = ChainId[chain]) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.toLowerCase(), ".svg");
        }
        return "/static/geniusImages/network_logos/".concat((_f = (_e = ChainId[chain]) === null || _e === void 0 ? void 0 : _e.toString()) === null || _f === void 0 ? void 0 : _f.toLowerCase(), ".png");
    }
    catch (e) {
        console.error('Error getting network logo for chain', chain, e);
        return '';
    }
}
